<template>
      <div class="mobile">
        <TopTabs :list="this.$nav20"/>

        <div class="image-box">
            <div class="tsnn_top">
                <div class="tsnn_title"
                  v-for="(item, index) in list" :key="index"
                  @click="toPage(index)">
                <div :class="index === id ? 'tsnn_active': ''">{{item}}</div>
                <div v-if="index == id"
                     :class="index === id ? 'tsnn_border': ''">
                </div>
             </div>
            </div>
            <ul class="father">
              <li v-for="(item, index) in imgList" :key="index" @click="preview(index)">
                <img :src="item.image_url" class="p3" />
                <div class="imgTitle" v-if="item.title !== ''">{{item.title}}</div>
              </li>
            </ul>
        </div>
      </div>

</template>

<script>
import { ImagePreview } from 'vant'
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: '',
  components: { TopTabs },
  props: {},
  data () {
    return {
      list: ['校园风景', '校园生活'],
      imgList: [],
      srcList: [],
      id: 0,
      type: 1
    }
  },

  computed: {},
  watch: {},
  created () {
    this.getList()
  },

  methods: {
    preview (index) {
      ImagePreview({
        images: this.srcList,
        startPosition: index
      })
    },
    async getList () {
      const { data } = await this.$get('/ow/scenery', { type: this.type })
      this.imgList = data
      for (var i = 0; i < data.length; i++) {
        this.srcList.push(data[i].image_url)
      }
    },
    toPage (index) {
      this.id = index
      if (index === 0) {
        this.type = 1
        this.getList()
      } else {
        this.type = 2
        this.getList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .mobile {

    .image-box {
       padding: 0 4.2667vw;
       min-height: 86.5vh;
      .father {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          width: 43.6vw;
          height: 28vw;
          margin-bottom: 9.3333vw;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .imgTitle {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 6.0667vw;
            line-height: 6.0667vw;
            font-size: 3.2vw;
            background:  rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 3.2vw;
          }
        }
      }
    }
     .tsnn_top {
        display: flex;
        justify-content: flex-start;
        padding: 3.7333vw 0;
        border-bottom: 1px solid #B3B3B3;
        margin-bottom: 2.1333vw;

        .tsnn_title {

          position: relative;
          margin-right: 4.2667vw;
          cursor: pointer;
            font-size: 3.2vw;
        }
        .tsnn_border {
          position: absolute;
          left: 1.9vw;
          bottom: -3.7333vw;
          width: 8.5333vw;
          height: 0.4vw;
          background: #02349C;
        }
        .tsnn_active {
          color: #02349C;
        }
     }
  }
</style>
